import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
// import { retry, catchError } from 'rxjs/operators';
// import { Observable, of, throwError } from "rxjs";
// import jwt_decode from "jwt-decode";
// import { HttpErrorResponse } from '@angular/common/http';
import { Validators, FormControl, FormGroup, FormBuilder, AbstractControl } from '@angular/forms';
import { SharedService }  from "../../services/shared.service";
import { SharedSignalService} from '../../services/shared-signal.service';
// import { BreakpointsService }  from "../../services/breakpoints.service";
import { TokenStorageService }  from "../../services/token-storage.service";
import { DisbursementSessionService }  from "../../services/disbursement-session.service";
import { BrandProfileService }  from "../../services/brand-profile.service";
import { UserAuthService }  from "../../services/user-auth.service";

import { IBrandProfile } from '../../interfaces/brand-profile';
import { IAuthToken } from '../../interfaces/auth-token';
// import { IDisbursementSession } from '../../interfaces/disbursement-session';
import { IPageContent } from '../../interfaces/page-content';
import { GenericField } from '../../classes/generic-field';
// import { BrandHeaderComponent } from '../../components/brand-header/brand-header.component';
// import { Title } from '@angular/platform-browser';


@Component({
  selector: 'app-customer-verification',
  templateUrl: './customer-verification.component.html',
  styleUrls: ['./customer-verification.component.css']
})
export class CustomerVerificationComponent {

  isHeaderShown: boolean = false;
  isSpinnerShown: boolean = true;

  envRegion!: string;
  sessionId!: string;

  brandStyleTheme: any = {};
  cvForm!: FormGroup;

  brandProfile!: IBrandProfile;
  pageContent!: IPageContent;
  isLogoutVisible: boolean = false;

  showErrorMessage: boolean = false;
  errorMessage: string = 'Incorrect credentials provided';

  // Customer identity verification fields
  cvFields: GenericField<string>[] = [];

  dsbMessage?: string = "";
  isDsbMessageShown: boolean = false;

  currentBreakpoint: string = '';

  public constructor(
    private fb: FormBuilder,
    private router: Router,
    private disbursementSessionService: DisbursementSessionService,
    private sharedService: SharedService,
    private sharedSignalService: SharedSignalService,
    private tokenStorageService: TokenStorageService,
    private userAuthService: UserAuthService,
    private brandProfileService: BrandProfileService
  ) {
  }

  get promptTitle() : string {
    return this.sharedService.getCustomizedPrompt("CUSTOMER_VERIFICATION_TITLE") || "";
  }

  get prompt() : string {
   return this.sharedService.getCustomizedPrompt("CUSTOMER_VERIFICATION_SUBTITLE") || "";
  }

  ngOnInit(): void {

    this.cvForm = this.fb.group({});

    // Get the current enviromental region
    // this.envRegion = this.sharedService.getEnvRegion();
    // this.sessionId = this.sharedService.getDsbSessionGuid();
    this.envRegion = this.sharedSignalService.envRegion();
    this.sessionId = this.sharedSignalService.dsbSessionGuid();
    console.log('ngOnInit - envRegion', this.envRegion);
    console.log('ngOnInit - sessionId', this.sessionId);

    // Get the current brand profile
    this.brandProfile = this.sharedService.getBrandProfile();
    if (this.brandProfile && this.brandProfile.brandCode) {
      // console.log('CustomerVerification - ngOnInit()', 'brandProfile found');
      this.init();
    } else {
      // console.log('CustomerVerification - ngOnInit()', 'brandProfile NOT found');
      this.brandProfileService.getBrandProfile(this.envRegion, this.sessionId)
      .subscribe(
        (response) => {
          if (response) {
            // console.log('CustomerVerification -brandProfile retrieved', response);
            this.brandProfile = response;
            this.sharedService.setBrandProfile(this.brandProfile);
            this.init();
          }
        }
      )
    }
  }

  // private getDisbursementSession() {
  //   console.log('getDisbursementSession - envRegion', this.envRegion);
  //   console.log('getDisbursementSession - sessionId', this.sessionId);
  //   this.disbursementSessionService.getDisbursementSession(this.envRegion, this.sessionId)
  //   .subscribe({
  //     next: (response) => {
  //       console.log('getDisbursementSession - response', response);
  //       if (response) {
  //         let disbursementSession = response;
  //         this.sharedService.setDisbursementSession(disbursementSession);
  //       }
  //     },
  //     error: (error) => {
  //       console.log('getDisbursementSession - error', error);
  //       this.errorMessage = 'Unable to establish a session for disbursements';
  //       this.showErrorMessage = true;
  //     },
  //     complete: () => {
  //       this.isSpinnerShown = false;
  //     }
  //   });
  // }

    // if (!(this.envRegion && this.sessionId)) {
    //   console.log('CustomerVerification', 'no parameters provided');
    //   this.errorMessage = 'At this time unable to establish a session for disbursements';
    //   this.showErrorMessage = true;
    //   return;
    // }



  private init() {
    console.log('init', 'entered');

    this.cvFields.length = 0;
    this.cvForm.reset();

    // Clear the cached list of disbursement occurrences
    this.sharedService.setDsbOccurrences(null);

    // Prepare the page header content
    this.pageContent = {
      headerTitle: this.sharedService.getCustomizedTitle('APP_TITLE') || '',
      headerSubtitle: this.sharedService.getCustomizedTitle('CUSTOMER_VERIFICATION') || '',
      headerAvatar: 'customers.png'
    }

    // Display customer identification validation fields if they are configured
    // console.log('this.brandProfile', this.brandProfile);
    // console.log('this.brandProfile.evFields', this.brandProfile.evFields);
    if (this.brandProfile.evFields) {
      this.brandProfile.evFields.forEach(cvField => {
        // console.log('cvField', cvField);
        this.cvFields.push({
            label: cvField.placeholder.literal,
            value: '',
            key: cvField.variableName,
            placeholder: cvField.placeholder.literal,
            pattern: cvField.pattern,  // "/^[0-9]{5}(?:-[0-9]{4})?$/"
            invalidFormatMsg: cvField.invalidFormatMsg
          });
          this.cvForm.addControl(cvField.variableName,
              new FormControl('', [Validators.required, Validators.pattern(cvField.pattern || '')]));
      })
    }
    // Get the full disbursement session object
    // this.getDisbursementSession();

    this.isHeaderShown = true;
  }
  //       else {
  //         this.dsbMessage = "Your session is no loger valid.  Please click on the invitation link from the eMail or from your pass in the digital wallet"; //this.sharedService.getCustomizedPrompt("INVALID_SESSION");
  //         this.isDsbMessageShown = true;
  //       }
  //       this.isSpinnerShown = false;
  //     }
  //   )
  // }


  onSubmit() {
    this.showErrorMessage = false;
    this.isSpinnerShown = true;
    const cvCredentials = new Map();
    if (this.cvFields) {
      this.cvFields.forEach(item => {
        cvCredentials.set(item.key, this.cvForm.get(item.key)?.value)
      });
    }
    this.disbursementSessionService.validateCustomer(this.envRegion, this.sessionId, cvCredentials)
    .subscribe({
      next: (response) => {
        if (!response) {
          console.log('validateCustomer','no response');
          this.errorMessage = 'Unable to validate the input';
          this.showErrorMessage = true;
          return;
        }
        if (!response.accountValid) {
          console.log('validateCustomer','invalid account');
          this.errorMessage = 'Invalid account';
          this.showErrorMessage = true;
          return;
        } 
        if (response.accountLocked) {
          console.log('validateCustomer','locked account');
          this.errorMessage = 'Locked account';
          this.showErrorMessage = true;
          return;
        } 
        console.log('validateCustomer - response',response );
        // Access token is not generated for locked accounts
        if (!response.accessToken) {
          this.errorMessage = 'Account info is not available at this time';
          this.showErrorMessage = true;
          return;
        }
        // All good with account verification - Save off the auth token
        let tokenString: string = response.accessToken || '';
        this.tokenStorageService.setAuthToken(tokenString);
        // Save off destination options for OTP
        this.tokenStorageService.setDestinationOptions(response.destinationOptions || []);
        // Cache disbursement session and branch profile for usage by other pages
        // this.sharedService.setEnvRegion(this.envRegion);
        if (this.brandProfile) {
          this.sharedService.setBrandProfile(this.brandProfile);
          // Find out user's privileges
          // let authToken : IAuthToken = jwt_decode(tokenString);
          let authToken: IAuthToken  = this.sharedService.jwtDecode(tokenString);
          let userName: string = authToken.sub;
          this.findUserPrivileges(userName);
        }
      },
      error: (response) => {
        // console.log('validateCustomer - error',response);
        this.errorMessage = 'Invalid account credentials';
        if (response.error) {
          if (response.error.accountValid && response.error.accountLocked) {
            this.errorMessage = 'Your account is locked - try again later';
          }
        }
        this.showErrorMessage = true;
      },
      complete: () => {
        this.isSpinnerShown = false;
      }
    });
  }

  // Find out user's privileges and save them off
  private findUserPrivileges(userName: string) {
    this.userAuthService.findUserPrivileges()
    .subscribe({
      next: (response) => {
        console.log('customer-verification.findUserPrivileges',response);
        if (response) {
          // Cache user privileges in the local storage
          this.tokenStorageService.setUserPrivileges(response);
          // Navigate to OTP validation page
        //  this.router.navigate(['/dsb-ocr']);
         this.router.navigate(['/ov-comp']);
        }
      },
      error: (error) => {
        console.log('findUserPrivileges',error);
      },
      complete: () => {
      }
    });
  }


  // private handleError(error: HttpErrorResponse) {

  //   if (error.status === 0) {
  //     // A client-side or network error occurred. Handle it accordingly.
  //     console.error('An error occurred:', error.error);
  //   } else {
  //     // The backend returned an unsuccessful response code.
  //     // The response body may contain clues as to what went wrong.
  //     console.error(
  //       `Backend returned code ${error.status}, body was: `, error.error);
  //   }
  //   // Return an observable with a user-facing error message.
  //   return;
  // }
}
